"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_jss_1 = require("react-jss");
var theme_1 = require("../../../mantine-theme/src");
var LINE_WIDTH = 4;
exports.default = react_jss_1.createUseStyles({
    alert: function (_a) {
        var color = _a.color, theme = _a.theme;
        return ({
            position: 'relative',
            padding: [theme.spacing.xs, theme.spacing.md],
            paddingLeft: theme.spacing.md + theme.spacing.xs / 2 + LINE_WIDTH,
            backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[9] : theme.white,
            border: "1px solid " + (theme.colorScheme === 'dark' ? theme.colors.dark[9] : theme.colors.gray[2]),
            '&::before': {
                content: '""',
                display: 'block',
                position: 'absolute',
                top: theme.spacing.xs,
                bottom: theme.spacing.xs,
                left: theme.spacing.xs,
                width: LINE_WIDTH,
                borderRadius: LINE_WIDTH,
                backgroundColor: theme_1.getThemeColor({ theme: theme, color: color, shade: 6 }),
            },
        });
    },
    title: function (_a) {
        var color = _a.color, theme = _a.theme;
        return ({
            boxSizing: 'border-box',
            color: theme_1.getThemeColor({ theme: theme, color: color, shade: 6 }),
            margin: 0,
            marginBottom: theme.spacing.xs / 2,
            textOverflow: 'ellipsis',
            overflow: 'hidden',
        });
    },
    body: function (_a) {
        var theme = _a.theme;
        return (__assign(__assign({}, theme_1.getFontStyles(theme)), { lineHeight: theme.lineHeight, borderBottomLeftRadius: theme.radius.sm, borderBottomRightRadius: theme.radius.sm, textOverflow: 'ellipsis', overflow: 'hidden', fontSize: theme.fontSizes.sm, color: theme.colorScheme === 'dark' ? theme.colors.dark[0] : theme.black, '&:only-child': {
                borderTopRightRadius: theme.radius.sm,
                borderTopLeftRadius: theme.radius.sm,
            } }));
    },
}, { link: true });
